import React from 'react'

import Section from '../../../react4xp/components/Section'
import QIdeaBg from '../../../react4xp/components/Svg/Others/QIdeaBg'
import QIdeaBgSmall from '../../../react4xp/components/Svg/Others/QIdeaBgSmall'
import Wind from '../../../react4xp/components/Svg/Others/Wind'
import QIdeaHero from '../../../react4xp/components/QIdeaHero'
import Mask from '../../../react4xp/components/Mask'
import RichText from '../../../react4xp/components/RichText'
import Sparkle from '../../../react4xp/components/Svg/Others/Sparkle'


function IdeaHeaderPart({colors, title, image, imageMedium, ideaIntro, cta, instructionsTitle, instructionsSteps, counter}) {
  return (
    <div className='page-q-idea page-q-idea--home'>
        <Section bgColor={colors.bgColor || 'blue'} paddingTop='small' className='hero'>
            <QIdeaBg className='svg-bg' />
            <QIdeaBgSmall className='svg-bg svg-bg--small' />
            <Wind className='svg-bg svg-bg--mobile' />
            <Wind className='svg-bg svg-bg--mobile svg-bg--mobile--2' />

            <div className='container relative z2'>

                <QIdeaHero
                    title={title}
                    subTitle={{
                        textTop: counter.textBefore,
                        number: counter.number,
                        textBottom: counter.textAfter
                    }}
                    src={image?.link}
                    alt={image?.alt}
                    srcMedium={imageMedium?.link}
                />

                <div className='share-your-idea'>
                    <div className='row'>
                        <div className='col-md-10 offset-md-1 col-xl-8 offset-xl-2'>
                            <Mask spacing='medium' bgColor='white' className='share-your-idea__box'>

                                <RichText
                                    className='text-big'
                                    content={ideaIntro}
                                />

                                {cta?.text && (
                                    <a className='animated-button' href={cta.href}>

                                        <Sparkle />

                                        <span className='button button-has-borders text-small hover-bg-blue-dark relative z2'>
                                            <span>
                                                {cta.text}
                                            </span>
                                        </span>

                                    </a>
                                )}

                            </Mask>
                        </div>
                    </div>
                </div>

                <div className='how-to'>
                    <div className='row'>
                        <div className='col-md-10 offset-md-1 col-xl-8 offset-xl-2'>
                            <Mask spacing='medium' bgColor='white'>

                                <h2 className='h3'>
                                    {instructionsTitle}
                                </h2>

                                <RichText
                                    className='custom-ol'
                                    content={instructionsSteps}
                                />

                            </Mask>
                        </div>
                    </div>
                </div>

            </div>
        </Section>
    </div>

  )
}

export default (props) => <IdeaHeaderPart {...props} />
